export default __webpack_public_path__ + "static/media/GPA_Banner_In_Our_Community.96a23376.jpg";